import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierLisVisibleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        fill={color}
      />
      <path
        d="M23.91 11.58C23.77 11.27 20.28 4 12 4C3.72 4 0.24 11.27 0.09 11.58C-0.03 11.85 -0.03 12.16 0.09 12.43C0.23 12.74 3.72 20.01 12 20.01C20.28 20.01 23.76 12.74 23.91 12.43C24.03 12.16 24.03 11.85 23.91 11.58ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierLisVisibleIcon.displayName = 'HierLisVisibleIcon';
